import aesReduxConstants from '../constants';
import severityApi from '../apis/severityApi';

const severityActions = function() {
  const actions = {};
  const constants = aesReduxConstants;

  actions.getSeverityList = function() {
    return function(dispatch) {
      severityApi.getSeverityList()
        .then((response) => {
          const severities = response.data.severityList;
          dispatch({ type: constants.GET_SEVERITY_LIST, severities });
        });
    };
  };

  return actions;
};

export default severityActions();
